import { render, staticRenderFns } from "./bottom.vue?vue&type=template&id=0e38e0ed&scoped=true"
import script from "./bottom.vue?vue&type=script&lang=js"
export * from "./bottom.vue?vue&type=script&lang=js"
import style0 from "./bottom.vue?vue&type=style&index=0&id=0e38e0ed&prod&lang=scss&scoped=true"
import style1 from "./bottom.vue?vue&type=style&index=1&id=0e38e0ed&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e38e0ed",
  null
  
)

export default component.exports